'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PushCartContainer = PushCartContainer;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _PushCart = require('../components/PushCart/PushCart');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function PushCartContainer(_ref) {
  var action = _ref.action,
      submitTo = _ref.submitTo,
      recommendedProducts = _ref.recommendedProducts;

  return _react2.default.createElement(_reactRedux.Provider, { store: window.store }, _react2.default.createElement(_PushCart.PushCart, { action: action, submitTo: submitTo, recommendedProducts: recommendedProducts }));
}

PushCartContainer.propTypes = {
  action: _propTypes2.default.string.isRequired,
  submitTo: _propTypes2.default.string.isRequired,
  recommendedProducts: _propTypes2.default.array.isRequired
};